<app-customer-selection-custom-config [cropYear]="cropYear"></app-customer-selection-custom-config>
